import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { StyledButton as Button } from '../../CommonComponents/Button';

const ToggleGroup = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 30px;
  background: #fff;
`;

const buttonColors = css`
  background: ${props => (props.isSelected ? '#0447fa' : 'transparent')};
  color: ${props => (props.isSelected ? '#ffffff' : '#7a7a7a')};
`;

const ToggleButton = styled(Button)`
  ${buttonColors}
  border: 1px solid #0447fa;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 1.7px;
  padding: 10px 20px;

  &:not(.disabled):hover,
  &:not(.disabled):focus,
  &:not(.disabled):active {
    ${buttonColors}
  }

  & + & {
    border-left: none;
  }

  &:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  &:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
`;

const SectionToggle = ({ onChange, currentView, views }) => {
  return (
    <ToggleGroup>
      <ToggleButton
        isSelected={currentView === views.NETWORTH}
        onClick={() => onChange(views.NETWORTH)}
      >
        ACCOUNTS
      </ToggleButton>
      <ToggleButton
        isSelected={currentView === views.TRANSACTIONS}
        onClick={() => onChange(views.TRANSACTIONS)}
      >
        TRANSACTIONS
      </ToggleButton>
    </ToggleGroup>
  );
};

SectionToggle.defaultProps = {
  onChange: () => {},
  currentView: null,
  views: {},
};

SectionToggle.propTypes = {
  onChange: PropTypes.func,
  currentView: PropTypes.string,
  views: PropTypes.shape({
    TRANSACTIONS: PropTypes.string,
    NETWORTH: PropTypes.string,
  }),
};

export default SectionToggle;
